module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "blue",
      "data-image": "../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RAEFTON")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_dashboard"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_createrfq"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/raw_templates/t_contacts"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(/static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo",
      "id": "test"
    }
  }, [_vm._v(" Add Contacts")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("New Contact")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "addContact_email",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addContact_name",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addContact_type",
      "name": "addContact_type"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("Person")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "addContact_website",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "addContact_phone",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addContact_address",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addContact_city",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_stateprov"
    }
  }, [_vm._v("State / Province")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addContact_stateprov",
      "name": "addContact_statprov"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_postalzip"
    }
  }, [_vm._v("Postal / Zip")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addContact_postalzip",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addContact_scountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addContact_scountry",
      "name": "addContact_country"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-simple btn-link btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52809bea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_add_contacts.vue
// module id = 711
// module chunks = 0